<template>
  <div :class="$style.wrapper">
    <template v-if="isLoading">
      <div
        v-for="n in 6"
        :key="`fav-skeleton-${n}`"
        :class="$style.cardSkeleton"
      >
        <div :class="['skeleton', $style.skeletonImage]"></div>
        <div :class="['skeleton', $style.skeletonLine]"></div>
        <div :class="['skeleton', $style.skeletonLineShort]"></div>
      </div>
    </template>
    <template v-else>
      <div v-if="!favorites || !favorites.length" :class="$style.emptyState">
        <p>Избранных товаров пока нет</p>
        <span>Добавьте товары в избранное, чтобы они появились здесь.</span>
      </div>
      <template v-else>
        <div
          v-for="item in favorites"
          :key="item.product_id"
          :class="$style.card"
          @click="openProduct(item.product_id)"
        >
          <div :class="$style.imageBox">
            <img :src="item.model.images[0]" :alt="item.title" />
          </div>
          <div :class="$style.title">{{ item.model.title }}</div>
          <div :class="$style.price">{{ item.price }} ₽</div>
          <button
            @click.stop="deleteFavorite(item.product_id)"
            :class="$style.favBtn"
            type="button"
          >
            <img src="@/assets/img/market/fill-like.svg" alt="" />
          </button>
        </div>
        <div v-if="isLoadingMore" :class="$style.loadingMore">
          <div :class="$style.loadingSpinner"></div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: "Favorites",
  data() {
    return {
      isLoading: true,
      isLoadingMore: false,
      hasMore: true,
      limit: 20,
      offset: 0,
    }
  },
  async mounted() {
    await this.loadFavorites(true)
    window.addEventListener("scroll", this.handleScroll)
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll)
  },
  computed: {
    favorites() {
      return this.$store.state.favorites.items
    },
  },
  methods: {
    async loadFavorites(reset = false) {
      if (reset) {
        this.offset = 0
        this.hasMore = true
        this.isLoading = true
      } else {
        if (!this.hasMore || this.isLoadingMore) return
        this.isLoadingMore = true
      }

      try {
        const response = await this.$store.dispatch("getFavorites", {
          limit: this.limit,
          offset: this.offset,
        })
        const newItems = response?.items || []

        // Проверяем, есть ли еще данные
        this.hasMore = newItems.length === this.limit
        if (this.hasMore) {
          this.offset += this.limit
        }
      } catch (error) {
        console.error("Ошибка при загрузке избранного:", error)
      } finally {
        this.isLoading = false
        this.isLoadingMore = false
      }
    },
    handleScroll() {
      if (this.isLoading || this.isLoadingMore || !this.hasMore) return

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const windowHeight = window.innerHeight
      const documentHeight = document.documentElement.scrollHeight

      // Загружаем, когда осталось 200px до конца
      if (scrollTop + windowHeight >= documentHeight - 200) {
        this.loadFavorites(false)
      }
    },
    async deleteFavorite(id) {
      try {
        await this.$store.dispatch("deleteFavorite", {
          product_id: id,
        })
      } catch (error) {
        console.error("Ошибка при удалении из избранного:", error)
      }
    },
    openProduct(id) {
      this.$router.push({
        name: "Product",
        params: { id },
      })
    },
  },
}
</script>

<style lang="scss" module>
.wrapper {
  margin-top: 0.5rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
  padding: 0.5rem 1rem;
}

.card {
  position: relative;
  cursor: pointer;
  img {
    transform: scale(-1, 1);
  }
}

.cardSkeleton {
  border: 1px solid #b8b8bc5c;
  border-radius: 0.75rem;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.skeletonImage {
  width: 100%;
  height: 5.5rem;
  border-radius: 0.5rem;
}

.skeletonLine {
  width: 100%;
  height: 0.875rem;
  border-radius: 0.5rem;
}

.skeletonLineShort {
  width: 60%;
  height: 0.75rem;
  border-radius: 0.5rem;
}

.imageBox {
  width: 8.75rem;
  height: 8.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 0.5rem auto;
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}

.tags {
  display: flex;
  gap: 0.25rem;
  margin-bottom: 0.5rem;
}

.tagNew {
  background: #ec66081a;
  color: #ec6608;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
}

.tagTrade {
  background: #0000000d;
  color: #00000040;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
}

.tagCount {
  background: #0000000d;
  color: #00000040;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
}

.title {
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.625rem;
  line-height: 1.25;
}

.price {
  font-size: 1rem;
  font-weight: 600;
}

.favBtn {
  position: absolute;
  right: 0.25rem;
  top: 0.25rem;
  width: 2rem;
  height: 2rem;
  background: transparent;
  padding: 0;
  margin: 0;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.emptyState {
  grid-column: 1 / -1;
  background: #ffffff;
  border-radius: 0.75rem;
  border: 1px dashed #d4d4db;
  padding: 2rem 1.25rem;
  text-align: center;
  color: #6f6f78;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.emptyState p {
  font-size: 1rem;
  font-weight: 600;
  color: #111111;
}

.emptyState span {
  font-size: 0.875rem;
  color: #6f6f78;
}

.loadingMore {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}

.loadingSpinner {
  width: 2rem;
  height: 2rem;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-top-color: #000;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}
</style>
